import React from 'react';
import { createPortal } from 'react-dom';
import { Button, Modal } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';

export const DeleteSharedListModal = ({ list, isLoading, onCloseModal, onDeleteSharedList }) => (
  <div
    role="presentation"
    data-testid="delete-list-modal"
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
  >
    {createPortal(
      <Modal
        title="Delete list?"
        isOpen
        onCancel={onCloseModal}
        actions={
          <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={onCloseModal}>
              Cancel
            </Button>
            <Button
              data-testid="delete-btn"
              variant="danger"
              onClick={() => onDeleteSharedList(list)}
              loading={isLoading}
            >
              Delete list
            </Button>
          </Flex>
        }
      >
        <Text>Deleting this list will:</Text>
        <Box as="ul" px="24px" pt="8px">
          <Box as="li">Permanently delete the list itself</Box>
          <Box as="li">Turn off its shared access if it&apos;s currently active</Box>
          <Box as="li">Not remove any contacts from your network</Box>
        </Box>
        <Text mt="3" fontWeight={500}>
          <Text as="span" mr="2">
            ⚠️
          </Text>
          This action cannot be undone.
        </Text>
      </Modal>,
      document.getElementById('portals'),
    )}
  </div>
);

DeleteSharedListModal.propTypes = {
  list: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDeleteSharedList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

DeleteSharedListModal.defaultProps = {
  isLoading: false,
};
